window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.frosmoGamesByFilterRepo = function () {

    var list = function (filterParam) {
        var url = 'https://inpref.com/recoApi/v2?origin=supersport_hr&method=strategy&strategy=most-popular-by-filter---mobile--100--affinity-&context={"page":{"category":{"categories":["' + filterParam + '"]}}}&cookieId=frosmopreview.l1cguvrz';

        return fetch(url)
            .then(function (response) {
                return response.json();
            })
    };

    return {
        list: list
    }
}();